import { ReactNode } from 'react'

import {
  Text,
  Primary13Regular,
  GreyGrey60,
  Flex
} from '@sequencehq/core-components'

type Props = {
  label: string
  control: ReactNode
}

export const SidebarField = ({ label, control }: Props) => (
  <Flex paddingY="6px" gap="16px" alignItems="center">
    <Text {...Primary13Regular} color={GreyGrey60} width="81px" flexShrink="0">
      {label}
    </Text>
    {control}
  </Flex>
)
